<template>
  <div class="wrapper" id="vehicleInfo">
    <div class="contentModule" >
      <div class="space-between theme">
        <div>
          <div class="insuranceTheme">泰康在线车险 - 填写信息</div>
          <div class="insuranceDescription"></div>
        </div>
      </div>
      <div class="section">
        <div class="customerIcon">
          <span class="icon"></span>
        </div>
        <div class="processProcedure">
          <div class="unit">
            <span>01</span>
            <span>车辆信息</span>
          </div>
        </div>
        <ul class="vehicleInfo">
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>投保所在地：</span>
            </div>
            <div class="layui-form sInfo" data-value="insuredType">
              <el-cascader
                v-model="insuredCode"
                :options="provincesList"
                :props="{ label: 'label'}"
                @change="insurancePlace"
                ref="insuredCode">
              </el-cascader>
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>车辆类型：</span>
            </div>
            <div class="sInfo carkindCode">
              <el-select @change="carKindPicker" v-model="carkindCode" placeholder="请选择车辆类型" >
                <el-option
                  v-for="item in carKindList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                  <span style="float: left">{{ item.label }}</span>
                </el-option>
              </el-select>
            </div>
            <div class="drivingPermitRecognition" v-show="ownerType == 1" @click="drivingPermitRecognitionState = true">
              <img src="../../../../../static/images/public/idCardRecognitionIcon.png" />
              <span>行驶证识别</span>
            </div>
          </li>
          <li v-show="carkindCode == 1">
            <div class="tit">
              <span class="must">*</span>
              <span>货车类型：</span>
            </div>
            <div class="sInfo">
              <el-select v-model="trucksKindCode" placeholder="请选择货车类型" >
                <el-option
                  v-for="item in trucksKindList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  <span style="float: left">{{ item.label }}</span>
                </el-option>
              </el-select>
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>车牌号码：</span>
            </div>
            <div class="sInfo">
              <div data-value="licenseNo">
                <span>粤></span>
                <input type="text" placeholder="请输入车牌号码" class="licenseNo" oninput="if(value.length>7)value=value.slice(0,7)" onKeyUp="value=value.replace(/[\W]/g,'')" @input="licenseNoInput" v-model="licenseNo">
                <div class="newVehicle" @click="isNewVehicle">
                  <span class="whetherAgree">
                      <img class="checkbox" src="../../../images/dutyInsurance/login/checkbox_no.png"
                           data-check="0" v-show="newVehicle == 0">
                      <img class="checkbox isCheck" src="../../../images/dutyInsurance/login/checkbox_yes.png" v-show="newVehicle == 1"
                           data-check="1" >
                  </span>
                  <span>新车未上牌</span>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>使用性质：</span>
            </div>
            <div class="sInfo">
              <el-select v-model="useNatureCode" placeholder="请选择使用性质" >
                <el-option
                  v-for="item in carkindCode == '0' ? carUseNatureList : truckUseNatureList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  <span style="float: left">{{ item.label }}</span>
                </el-option>
              </el-select>
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>车架号：</span>
            </div>
            <div class="sInfo" data-value="frameNo">
              <input type="text" placeholder="请按行驶证输入17位“车辆识别代号”" class="frameNo" @input="frameNoInput" v-model="frameNo">
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>发动机号：</span>
            </div>
            <div class="sInfo" data-value="engineNo">
              <input type="text" placeholder="请按行驶证输入“发动机号”" class="engineNo"  v-model="engineNo">
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>车辆注册日期：</span>
            </div>
            <div class="sInfo dateSelector" data-value="enrollDate">
              <el-date-picker
                v-model="enrollDate"
                :picker-options="enrollDateDisable"
                value-format="yyyy-MM-dd"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                align="center"
                placeholder="请按行驶证选择“注册日期”"
                class="my-el-date-picker"
                :editable="false"
                @change="enrollDatePicker"
              >
              </el-date-picker>
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>车辆型号：</span>
            </div>
            <div class="sInfo" data-value="vehicleModel">
              <input type="text" placeholder="行驶证“品牌型号”英文数字部分" class="vehicleModel" onKeyUp="value=value.replace(/[\W]/g,'')"  v-model="vehicleModel">
            </div>
          </li>
          <li>
            <div class="tit">
              <span>车辆品牌：</span>
            </div>
            <div class="sInfo" data-value="vehicleBrand">
              <input type="text" placeholder='行驶证"品牌型号"中文部分,如"比亚迪"' class="vehicleBrand"  v-model="vehicleBrand">
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>座位数：</span>
            </div>
            <div class="sInfo" data-value="seatCount">
              <input type="text" onkeyup="value=value.replace(/[^\d]/g,'')" oninput="if(value.length>2)value=value.slice(0,2)" placeholder="请按行驶证输入“车辆座位数”" class="seatCount"  v-model="seatCount">
            </div>
          </li>
          <!--<li>
            <div class="tit">
              <span class="must">*</span>
              <span>新车购置价：</span>
            </div>
            <div class="sInfo" data-value="replacementValue">
              <input type="text" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入新车购置价" class="replacementValue"  v-model="replacementValue">
            </div>
          </li>-->
          <li style="height: 80px" v-show="fuelType == 9">
            <div class="tit">
              <span class="must">*</span>
              <span>能源种类描述：</span>
            </div>
            <div class="sInfo" data-value="otherEnergyTypeDesc">
              <textarea maxlength="200" class="textInput otherEnergyTypeDesc" placeholder="其他燃料（能源）种类描述，文字录入最多200个汉字；" v-model="otherEnergyTypeDesc"></textarea>
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>是否外地车：</span>
            </div>
            <div class="sInfo" data-value="ecdemicVehicle">
              <el-radio v-model="ecdemicVehicle" label="1">是</el-radio>
              <el-radio v-model="ecdemicVehicle" label="0">否</el-radio>
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>是否过户车：</span>
            </div>
            <div class="sInfo" data-value="chgOwnerFlag">
              <el-radio v-model="chgOwnerFlag" label="1">是</el-radio>
              <el-radio v-model="chgOwnerFlag" label="0">否</el-radio>
            </div>
          </li>
          <li v-show="chgOwnerFlag == 1">
            <div class="tit">
              <span class="must">*</span>
              <span>过户日期：</span>
            </div>
            <div class="sInfo dateSelector" data-value="enrollDate">
              <el-date-picker
                v-model="transferDate"
                :picker-options="transferDateDisable"
                value-format="yyyy-MM-dd"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                align="center"
                placeholder="请选择过户日期"
                class="my-el-date-picker"
                :editable="false"
              >
              </el-date-picker>
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>是否车贷多年：</span>
            </div>
            <div class="sInfo" data-value="loanFlag">
              <el-radio v-model="loanFlag" label="1">是</el-radio>
              <el-radio v-model="loanFlag" label="0">否</el-radio>
            </div>
          </li>
          <li v-show="newVehicle == 1">
            <div class="tit">
              <span class="must">*</span>
              <span>4S店：</span>
            </div>
            <div class="sInfo" data-value="company4s">
              <input type="text" placeholder="请输入4S店名称" class="company4s"  v-model="company4s">
            </div>
          </li>
          <li v-show="newVehicle == 1">
            <div class="tit">
              <span class="must">*</span>
              <span>4S店所在省市：</span>
            </div>
            <div class="layui-form sInfo" data-value="companyType">
              <el-cascader
                v-model="companyCity"
                :options="companyProvinceList"
                :props="{ label: 'label'}"
                placeholder="请选择4S店所在省市"
                @change="companyProvinceValue"
                ref="companyCity">
              </el-cascader>
            </div>
          </li>
        </ul>

        <div class="processProcedure">
          <div class="unit">
            <span>02</span>
            <span>车主信息</span>
          </div>
        </div>
        <ul class="ownerInfo">
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>车主性质：</span>
            </div>
            <div class="sInfo">
              <el-select @change="ownerTypePicker" v-model="ownerType" placeholder="请选择车主性质" >
                <el-option
                  v-for="item in ownerTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  <span style="float: left">{{ item.label }}</span>
                </el-option>
              </el-select>
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>车主名称：</span>
            </div>
            <div class="sInfo" data-value="ownerName">
              <input type="text" placeholder="请输入车主真实姓名" class="ownerName"  v-model="ownerName">
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>证件类型：</span>
            </div>
            <div class="sInfo ownerIdtypelabel">
              <el-select v-model="ownerIdtypelabel" placeholder="请选择证件类型" disabled="disabled" >
                <el-option
                  v-for="item in ownerIdtypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  <span style="float: left">{{ item.label }}</span>
                </el-option>
              </el-select>
            </div>
            <div class="idCardRecognition" v-show="ownerType == 1" @click="idCardRecognitionState = true">
              <img src="../../../../../static/images/public/idCardRecognitionIcon.png" />
              <span>身份证识别</span>
            </div>
          </li>
          <li>
            <div class="tit">
              <span class="must">*</span>
              <span>证件号码：</span>
            </div>
            <div class="sInfo" data-value="ownerIdnumber">
              <input type="text" onKeyUp="value=value.replace(/[\W]/g,'')" @input="ownerIdnumberInput" placeholder="请输入证件号码" class="ownerIdnumber"  v-model="ownerIdnumber">
            </div>
          </li>
          <li v-show="ownerType == 1">
            <div class="tit">
              <span class="must">*</span>
              <span>车主生日：</span>
            </div>
            <div class="sInfo dateSelector" data-value="ownerBrithday">
              <el-date-picker
                v-model="ownerBrithday"
                :picker-options="ownerBrithdayDisable"
                value-format="yyyy-MM-dd"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                align="center"
                placeholder="请选择车主生日"
                class="my-el-date-picker"
                :editable="false"
              >
              </el-date-picker>
            </div>
          </li>
          <li v-show="ownerType != 1">
            <div class="tit">
              <span class="must">*</span>
              <span>注册日期：</span>
            </div>
            <div class="sInfo dateSelector" data-value="recordDate">
              <el-date-picker
                v-model="recordDate"
                :picker-options="ownerBrithdayDisable"
                value-format="yyyy-MM-dd"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                align="center"
                placeholder="请选择注册日期"
                class="my-el-date-picker"
                :editable="false"
              >
              </el-date-picker>
            </div>
          </li>
          <li v-show="ownerType == 1">
            <div class="tit">
              <span class="must">*</span>
              <span>车主性别：</span>
            </div>
            <div class="sInfo" data-value="loanFlag">
              <el-radio v-model="ownerSex" label="M">男</el-radio>
              <el-radio v-model="ownerSex" label="F">女</el-radio>
            </div>
          </li>
        </ul>

        <div class="step space-around">
          <button class="nextStep" id="submitOrder" @click="submitOrder()" data-value="1" onmouseover="this.style.backgroundColor='#ff8a73';" onmouseout="this.style.backgroundColor='#ff7052';" onmouseup="this.style.backgroundColor='#d95e45';">保存</button>
        </div>
      </div>
    </div>

    <el-dialog
      title="历史报价车辆记录"
      :visible.sync="queryCarInfoState"
      :with-header="false"
      direction="btt"
      top="40vh"
      center
    >
      <div class="loadCarInfoList">
        <el-select v-model="loadCarInfoValue" @change="loadCarInfo(queryCarInfoList[loadCarInfoValue])" placeholder="请选择一项历史报价车辆记录" >
          <el-option
            v-for="item in queryCarInfoSelectList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            <span style="float: left">{{ item.label }}</span>
          </el-option>
        </el-select>
      </div>
    </el-dialog>

    <el-dialog
      title="可报价车辆列表"
      :visible.sync="carInfoState"
      :with-header="false"
      direction="btt"
      top="40vh"
      center
    >
      <div class="loadCarInfoList">
        <el-select v-model="carInfoValue" @change="saveCarModelQuery(carInfoList[carInfoValue])" placeholder="请选择您报价的车辆" >
          <el-option
            v-for="item in carInfoSelectList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            <span style="float: left">{{ item.label }}</span>
          </el-option>
        </el-select>
      </div>
    </el-dialog>

    <el-dialog
      title="行驶证采集"
      :visible.sync="drivingPermitRecognitionState"
      :with-header="false"
      direction="btt"
      center
    >
      <div class="insuran-con generalWrap">
        <div class="topTips">请把身份证从保护套里拿出来拍照，以免反光影响信息采集的正确率。</div>
        <div class="content">
          <div class="title">拍摄上传行驶证正页（红章页）</div>
          <div class="exampleUnit">
            <div class="example">
              <img id="drivingPermitFront" src="../../../../../static/images/public/autoInsurance/drivingPermit-1.png" />
            </div>
            <div class="upload">
              <input type="file" data-id="drivingPermitFront" accept="image/*" @change="selectDrivingPermit('front')" ref="drivingPermitFront" />
            </div>
          </div>
          <div class="title">拍摄上传行驶证副页（条码页）</div>
          <div class="exampleUnit">
            <div class="example">
              <img id="drivingPermitBack" src="../../../../../static/images/public/autoInsurance/drivingPermit-2.png" />
            </div>
            <div class="upload">
              <input type="file" data-id="drivingPermitBack" accept="image/!*" @change="selectDrivingPermit('back')" ref="drivingPermitBack" />
            </div>
          </div>
          <div class="norm">拍照请参照以下规范:</div>
          <div class="normList space-between">
            <div>
              <div>
                <img class="example" src="../../../../../static/images/public/autoInsurance/drivingPermitExample-1.png" />
              </div>
              <div class="explain">
                <img src="../../../../../static/images/public/autoInsurance/right.png" />
                <span>正确</span>
              </div>
            </div>
            <div>
              <div>
                <img class="example" src="../../../../../static/images/public/autoInsurance/drivingPermitExample-2.png" />
              </div>
              <div class="explain">
                <img src="../../../../../static/images/public/autoInsurance/wrong.png" />
                <span>边角缺失</span>
              </div>
            </div>
            <div>
              <div>
                <img class="example" src="../../../../../static/images/public/autoInsurance/drivingPermitExample-3.png" />
              </div>
              <div class="explain">
                <img src="../../../../../static/images/public/autoInsurance/wrong.png" />
                <span>相片模糊</span>
              </div>
            </div>
            <div>
              <div>
                <img class="example" src="../../../../../static/images/public/autoInsurance/drivingPermitExample-4.png" />
              </div>
              <div class="explain">
                <img src="../../../../../static/images/public/autoInsurance/wrong.png" />
                <span>曝光过度</span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="healthSubmitBtn" data-index="0" @click="drivingPermitRecognitionState = false">取消</div>
          <div class="healthSubmitBtn" data-index="1" @click="uploadDrivingPermit">立即上传</div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="身份证采集"
      :visible.sync="idCardRecognitionState"
      :with-header="false"
      direction="btt"
      center
    >
      <div class="insuran-con generalWrap">
        <div class="topTips">请把身份证从保护套里拿出来拍照，以免反光影响信息采集的正确率。</div>
        <div class="content">
          <div class="title">拍摄上传身份证人脸页</div>
          <div class="exampleUnit">
            <div class="example">
              <img id="idCardData" src="../../../../../static/images/public/autoInsurance/idCard-1.png" />
            </div>
            <div class="upload">
              <input type="file" data-id="idCardData" accept="image/*" @change="selectIdCard" ref="idCardData" />
            </div>
          </div>
          <div class="norm">拍照请参照以下规范:</div>
          <div class="normList space-between">
            <div>
              <div>
                <img class="example" src="../../../../../static/images/public/autoInsurance/idCardExample-1.png" />
              </div>
              <div class="explain">
                <img src="../../../../../static/images/public/autoInsurance/right.png" />
                <span>正确</span>
              </div>
            </div>
            <div>
              <div>
                <img class="example" src="../../../../../static/images/public/autoInsurance/idCardExample-2.png" />
              </div>
              <div class="explain">
                <img src="../../../../../static/images/public/autoInsurance/wrong.png" />
                <span>边角缺失</span>
              </div>
            </div>
            <div>
              <div>
                <img class="example" src="../../../../../static/images/public/autoInsurance/idCardExample-3.png" />
              </div>
              <div class="explain">
                <img src="../../../../../static/images/public/autoInsurance/wrong.png" />
                <span>相片模糊</span>
              </div>
            </div>
            <div>
              <div>
                <img class="example" src="../../../../../static/images/public/autoInsurance/idCardExample-4.png" />
              </div>
              <div class="explain">
                <img src="../../../../../static/images/public/autoInsurance/wrong.png" />
                <span>曝光过度</span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="healthSubmitBtn" data-index="0" @click="idCardRecognitionState = false">取消</div>
          <div class="healthSubmitBtn" data-index="1" @click="uploadIdCard">立即上传</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
    import province from '../../../../../src/tool/resource/province.js';

    export default {
      name: "vehicleInfo",
      data() {
        return {
          // 车辆信息
          idCardData: '',                     // 身份证识别 - 选择图片
          formDataList: {},                   // 已选上传图片集合
          insuredCode: '440100',              // 投保所在地 - 编码
          licensePrefix: '粤A',               // 投保所在地 - 车牌简称
          carkindCode: '0',                   // 车辆类型
          trucksKindCode: 'H0',               // 货车类型
          licenseNo: null,                    // 车牌号
          newVehicle: '0',                    // 新旧车标志：1：是（未上牌）、0：不是，默认为0；
          useNatureCode: '8A',                // 车辆使用性质，默认‘8A-家庭自用汽车’
          frameNo: null,                      // 车架号
          engineNo: null,                     // 发动机号
          enrollDate: null,                   // 车辆注册日期：yyyy-MM-dd
          enrollDateDisable: {                // 车辆注册日期 - 期限
            disabledDate(time) {
              const date = new Date(Date.now());
              return time.getTime() > new Date(date - 1 * 24 * 60 * 60 * 1000);
            },
          },
          vehicleModel: null,                 // 车辆型号
          vehicleBrand: '',                   // 车辆品牌
          seatCount: null,                    // 座位数，包含驾驶位的座位数
          chgOwnerFlag: '0',                  // 过户车标识：1：是、0：不是，默认为0
          transferDate: null,                 // 过户日期（转移登记日期）：yyyy-MM-dd，过户车标识为1时显示必填
          transferDateDisable: {              // 过户日期 - 期限
            disabledDate(time) {
              const date = new Date(Date.now());
              return time.getTime() > new Date(date - 1 * 24 * 60 * 60 * 1000);
            },
          },
          loanFlag: '0',                      // 是否车贷多年：1：是，0：否，默认为0
          company4s: null,                    // 车辆销售公司名称，广东新车必录
          companyProvince: '440000',          // 4s公司所在省份编码
          companyCity: '440100',              // 4s公司所在地编码
          certificateType: '01',              // 车辆来历凭证种类
          certificateNo: null,                // 车辆来历凭证编号
          certificateDate: null,              // 车辆来历凭证所载日期

          // 额外内容
          marketYear: null,                   // 上市年份：yyyy
          ecdemicVehicle: '0',                // 外地车标志：1-是、0-不是；
          replacementValue: null,             // 新车购置价
          fuelType: '0',                      // 能源类型，非燃油是新能源车（0：燃油；1：纯电动；2：燃料电池；3：插电式混合动力；4：其他混合动力；9：其他；）
          isNewEnergy: '0',                   // 是否新能源车，能源类型为0值为0，否则为1
          otherEnergyTypeDesc: null,          // 其他燃料（能源）种类描述，当能源类型为9-其他时，必填；
          pureRange: null,                    // 纯电续航里程，燃油类型不为0时显示，仅支持大于等于0的纯数字，支持小数点后1位，例如400.1；
          vehicleCode: null,                  // 精友车型编码
          vehicleHyCode: null,                // 行业车型编码
          carModelKey: null,                  // 车型信息关键字
          vehicleDescription: null,           // 车型描述
          exhaustScale: null,                 // 排气量：单位：mL(整数8位，小数4位)，车辆种类为货车时必传
          fullWeight: null,                   // 整备质量：单位：千克，车辆种类为货车时必传

          // 车主信息
          ownerType: '1',                     // 车主性质：1：个人；2：机关/团体；3：企业；6：个体工商户（同企业）
          ownerName: null,                    // 车主名称
          ownerIdtype: '1',                   // 车主证件类型value，车主性质个人：1-身份证，非个人：6-统一社会信用代码，
          ownerIdtypelabel: '身份证',          // 车主证件类型label，车主性质个人：1-身份证，非个人：6-统一社会信用代码，
          ownerIdnumber: null,                // 车主证件号码
          ownerBrithday: null,                // 车主生日
          ownerBrithdayDisable: {             // 车主生日/注册日期 - 期限
            disabledDate(time) {
              const date = new Date(Date.now());
              return time.getTime() > new Date(date - 1 * 24 * 60 * 60 * 1000);
            },
          },
          ownerSex: 'M',                      // 车主性别
          recordDate: null,                   // 车主注册日期

          beShareToken: null,                 // 被分享token
          shareToken: null,                   // 分享token
          quoteIdNum: null,                   // 报价订单ID
          productId: '100464',                // 产品ID
          eventLogToken: null,                 // 事件日志Token
          queryCarInfoState: false,           // 历史报价车辆记录 - 弹窗状态
          queryCarInfoSelectList: [],         // 历史报价车辆记录 - 弹窗选择列表
          queryCarInfoList: [],               // 历史报价车辆记录列表
          loadCarInfoValue: null,             // 历史报价车辆记 - 默认值

          // 查车
          carInfoList: [],                    // 查车返回列表
          carInfoState: false,                // 查车返回列表 - 弹窗状态
          carInfoSelectList: [],              // 查车返回列表 - 弹窗选择列表
          carInfoValue: null,                 // 查车返回列表 - 默认值

          drivingPermitRecognitionState: false,       // 行驶证识别 - 弹窗状态
          idCardRecognitionState: false,              // 身份证识别 - 弹窗状态

          carKindList: [{label: '客车', value: '0'}, {label: '货车', value: '1'}],
          trucksKindList: [{label: '载货机动车', value: 'H0'}, {label: '低速载货汽车', value: 'H1'}, {label: '厢式货车', value: 'H3'}],
          carUseNatureList: [{label: '家庭自用汽车', value: '8A'}, {label: '非营业企业客车', value: '8B'}, {label: '非营业党政机关事业团体客车', value: '8C'}],
          truckUseNatureList: [{label: '非营业货车', value: '8D'}, {label: '营业货车', value: '9D'}],
          ownerTypeList: [{label: '个人', value: '1'}, {label: '企业', value: '2'}, {label: '机关/团体', value: '3'}],
          ownerIdtypeList: [{label: '身份证', value: '1'}, {label: '统一社会信用代码', value: '6'}],
          fuelTypeList: [{label: '燃油', value: '0'}, {label: '纯电动', value: '1'}, {label: '燃料电池', value: '2'}, {label: '插电式混合动力', value: '3'}, {label: '其他混合动力', value: '4'}, {label: '其他', value: '9'}],
          certificateTypeList: [{label: '销售发票', value: '01'}, {label: '法院调解书', value: '02'}, {label: '法院裁定书', value: '03'}, {label: '法院判决书', value: '04'}, {label: '仲裁裁决书', value: '05'},
            {label: '相关文书(继承、赠予、协议抵债)', value: '06'}, {label: '批准文件', value: '07'}, {label: '调拨证明', value: '08'}, {label: '修理发票', value: '09'}],

          provincesList: province.provincesList,
          companyProvinceList: province.companyProvinceList,
        }
      },
      methods: {
        //-- 事件绑定
        eventBinding() {
          let that = this;

          //-- 找客服 二维码 绑定事件
          $(".customerIcon").on("click", function(){
            window.open('https://work.weixin.qq.com/kfid/kfce82ed2eaaae38c7f');
          });
        },
        // 行驶证识别 - 选择
        selectDrivingPermit(name){
          let file;
          if (name == 'front'){
            file = this.$refs.drivingPermitFront.files[0];
            this.compressImages(file, 'drivingPermitFront');
          }else if (name == 'back'){
            file = this.$refs.drivingPermitBack.files[0];
            this.compressImages(file, 'drivingPermitBack');
          }
        },
        // 行驶证识别 - 上传
        uploadDrivingPermit() {
          let that = this,
            id = 'drivingPermitFront';

          if (!that.$$.isValidObj(that.formDataList[id]) || !that.$$.isValidObj(that.formDataList['drivingPermitBack'])) return;
          that.fileUploadHandler(id);
        },
        // 身份证识别 - 选择
        selectIdCard(){
          let file = this.$refs.idCardData.files[0];
          this.compressImages(file, 'idCardData');
        },
        // 身份证识别 - 上传
        uploadIdCard() {
          let that = this,
            id = 'idCardData';

          if (!that.$$.isValidObj(that.formDataList[id])) return;
          that.fileUploadHandler(id);
        },
        //-- 压缩图片
        compressImages(file, id) {
          let that = this;

          //-- file>2M照片压缩到2M，file<=2M不压缩 （半身正面照片压缩到200K）
          that.imageConversion.compressAccurately(file, 2048).then(res => {
            res = new File([res], file.name, {type: res.type, lastModified: Date.now()});

            let reader = new FileReader();
            reader.readAsDataURL(res);
            reader.onload = function(event) {
              let base64 = event.target.result;

              $(`#${id}`).attr("src", base64);
            };

            let formData = new window.FormData(),
              cardSide = '0';
            formData.append("file", res);
            formData.append("formType", id == 'idCardData' ? '30002' : '30005');
            if (id == 'drivingPermitBack') cardSide = '1';
            formData.append("cardSide", cardSide );
            that.formDataList[id] = formData;

            // 已选图片 - 允许上传识别
            let length = Object.keys(that.formDataList).length;
            if (length >= 2 || id == 'idCardData') $('.healthSubmitBtn[data-index="1"]').addClass('on');
          });
        },
        // 文件上传 - 识别
        fileUploadHandler(id){
          let that = this,
            formData = that.formDataList[id];

          let formType = formData.get('formType');

          that.$$.loading("识别中...");
          that.$$.request({
            url: that.UrlConfig.upload_attachment_uploadFileByComplex,
            pars: formData,
            requestBody: true,
            sfn: function (data) {
              that.$$.closeLoading();

              const { success, msg, datas } = data;
              if (success) {
                that.$message.success("识别成功！");

                switch (formType) {
                  case '30001':{
                    // responseHandler_30001(datas, id);
                    break;
                  }
                  case '30002':{
                    responseHandler_30002(datas, id);
                    break;
                  }
                  case '30005':{
                    responseHandler_30005(datas, id);
                    break;
                  }

                }
              } else {
                that.$message.error(msg);
              }
            },
            ffn: function (data) {
              that.$$.errorHandler();
            }
          });

          // 身份证识别 -> 响应处理
          function responseHandler_30002(data, id){
            const { name, idCardNumber } = data;

            if(that.$$.isValidObj(idCardNumber)){
              that.ownerName = name;
              that.ownerIdnumber = idCardNumber;
              //-- 身份证转换
              that.idCardConversion(idCardNumber);
              that.idCardRecognitionState = false;

              that.$message.success("识别成功！");
            }else{
              that.$message.error("未识别到证件号，请重试！");
            }
          }

          // 行驶证识别 -> 响应处理
          function responseHandler_30005(data, id){
            let reg = /[a-zA-Z0-9]/g,
              numberReg = /[0-9]/g,
              strReg = /[\u4E00-\u9FA5]/g;

            if (id == 'drivingPermitFront') {
              const {licenseNo, vehicleNumber, engineNo, registerDate, brandName, owner} = data;

              // 车牌号码
              if (that.$$.isValidObj(licenseNo)){

                let name = licenseNo.match(strReg).join('');
                let value = licenseNo.match(reg).join('');

                if (name == '粤'){
                  that.licenseNo = value;
                }else {
                  that.$$.alert({message: `行驶证车牌号码：${licenseNo} ,不是广东省(粤)车牌，请重新上传！`});
                  that.$$.throw();
                }
              }

              // 车架号
              if (that.$$.isValidObj(vehicleNumber)) that.frameNo = vehicleNumber;

              // 发动机号
              if (that.$$.isValidObj(engineNo)) that.engineNo = engineNo;

              // 车辆注册日期
              if (that.$$.isValidObj(registerDate)) {
                let enrollDate = registerDate.replace(/(.{4})(.{~2})/, "$1-$2-");
                that.enrollDate = enrollDate;
              }

              // 品牌型号 - 车辆型号/车辆品牌
              if (that.$$.isValidObj(brandName)) {
                let name = brandName.match(strReg).join('');
                let value = brandName.match(reg).join('');

                that.vehicleModel = value;
                that.vehicleBrand = name;
              }

              // 发动机号
              if (that.$$.isValidObj(owner)) that.engineNo = engineNo;


              that.fileUploadHandler('drivingPermitBack');
            }else if (id == 'drivingPermitBack'){
              const {fullWeight, seatCount} = data;

              // 整备质量
              if (that.$$.isValidObj(fullWeight)) {
                // let value = fullWeight.match(numberReg).join('');
                // $('.fullWeightValue').val(value);
              }

              // 座位数
              if (that.$$.isValidObj(seatCount)) {
                let value = seatCount.match(numberReg).join('');
                that.seatCount = value;
              }

              that.drivingPermitRecognitionState = false;
            }
          }
        },
        // 投保所在地
        insurancePlace(value){
          this.insuredCode = value[1];
          this.licensePrefix = this.$refs["insuredCode"].getCheckedNodes()[0].data.licensePrefix;
        },
        //车辆类型
        carKindPicker(value){
          if(value == 1){
            this.useNatureCode = '8D';
          }else{
            this.useNatureCode = '8A';
          }
        },
        // 车牌号码
        licenseNoInput(e){
          let that = this,
            value = e.target.value;
          if (!that.$$.isValidObj(value)) return false;

          if (value.length == 1){
            let letterReg = /^[a-zA-Z]+$/;
            value = letterReg.test(value) ? value.toUpperCase() : '';
            that.licenseNo = value;

            // 是否外地车
            that.ecdemicVehicle = that.licensePrefix == `粤${value}` ? '0':'1';
          }
        },
        // 是否 - 新车未上牌
        isNewVehicle(){
          if(this.newVehicle == 1){
            this.newVehicle = 0;
          }else{
            this.newVehicle = 1;
          }
        },
        // 车架号
        frameNoInput(e){
          let that = this,
            value = e.target.value;

          if (value.length == 17) that.queryCarInfo(value);
        },
        // 车辆注册日期
        enrollDatePicker(value){
          // 判断9个月内为 - 新车
          let nowDate = new Date();
          nowDate.setMonth(nowDate.getMonth() - 9);
          let time = new Date(value.replace(/-/g,'/')).getTime(),
            nowTime = nowDate.getTime();

          this.newVehicle = time >= nowTime ? '1' : '0';
        },
        // 4S店所在省市
        companyProvinceValue(value){
          this.companyProvince = value[0];
          this.companyCity = value[1];
        },
        // 车主性质
        ownerTypePicker(value){
          if(value == 1){
            this.ownerIdtype = this.ownerIdtypeList[0].value;
            this.ownerIdtypelabel = this.ownerIdtypeList[0].label;
            // 身份证转换
            this.idCardConversion(this.ownerIdnumber);
          }else{
            this.ownerIdtype = this.ownerIdtypeList[1].value;
            this.ownerIdtypelabel = this.ownerIdtypeList[1].label;
            this.ownerSex = 'O';
          }
        },
        // 车主证件号
        ownerIdnumberInput(e){
          let that = this,
            value = e.target.value;

          // 身份证转换
          that.idCardConversion(value);
        },
        // 身份证转换
        idCardConversion(value){
          let that = this;
          if (!that.$$.isValidObj(value) || that.ownerIdtype != '1' || value.length < 18) return false;

          // 性别
          let sexType = parseInt(value.substr(16,1))%2 == 1;
          sexType = sexType ? 'M':'F';
          that.ownerSex = sexType;

          // 出生日期
          let birthday = value.slice(6, 14);
          birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");   //通过正则表达式来指定输出格式为:1990-01-01
          that.ownerBrithday = birthday;
        },
        //-- 获取分享token
        createShareToken() {
          let that = this;

          that.$$.request({
            url: that.UrlConfig.management_quotecarinsurance_createShareToken,
            method : 'GET',
            sfn: function (data) {

              const { success, msg, datas } = data;
              if (success) {
                const {shareToken, requestToken} = data['datas'];
                that.shareToken = shareToken;

                if (!that.$$.isValidObj(that.eventLogToken)) {
                  let id = decodeURIComponent(encodeURIComponent(requestToken).replace(new RegExp("%20","gm"),"%2B"));
                  that.eventLogToken = id;

                  // 修改 - URL全部参数
                  let { origin, pathname } = window.location,
                    {beShareToken, quoteIdNum} = that,
                    params = {eventLogToken: id};

                  if (that.$$.isValidObj(beShareToken)) params[beShareToken] = beShareToken;
                  if (that.$$.isValidObj(quoteIdNum)) params[quoteIdNum] = quoteIdNum;
                  let urlPars = that.$$.jsonToUrlParams(params),
                    url = origin + pathname + urlPars;
                  history.pushState("", "", url);

                  // 产品屏幕录制
                  that.recording();
                }
              } else {
                that.$message.error(msg);
              }
            },
            ffn: function (data) {
              that.$$.errorHandler();
            }
          });
        },
        // 产品屏幕录制
        recording(){
          let that = this;
          let eventLogToken = decodeURIComponent(encodeURIComponent(that.eventLogToken).replace(new RegExp("%20","gm"),"%2B"));
          if (that.$$.isValidObj(eventLogToken)) {
            that.screenRecBase.startLoad();
            that.eventLogToken = eventLogToken;
          }
        },
        //-- 获取车辆信息
        getCarInfo(){
          let that = this;
          that.axios.post('/management/quotecarinsurance/getQuotation',{
            quoteIdNum: that.quoteIdNum,
            beShareToken: that.beShareToken,
          }).then((response) => {
            let data = response.data;
            if (data.success) {
              const {car, isLockMsg} = data['datas'];
              // if (that.$$.isValidObj(isLockMsg)) that.$message.error(isLockMsg);

              that.loadCarInfo(car);
            } else {
              that.$message.error(data.msg);
            }
          });
        },
        loadCarInfo(data){
          // 车辆信息解析
          let that = this;
          Object.assign(that.$data, data);
          let {licenseNo, ecdemicVehicle, chgOwnerFlag, fuelType, isNewEnergy, loanFlag, newVehicle, ownerIdtype, ownerIdnumber, ownerType, ownerBrithday, carkindCode} = data;

          that.licenseNo = licenseNo.slice(1);
          that.ecdemicVehicle = ecdemicVehicle.toString();
          that.chgOwnerFlag = chgOwnerFlag.toString();
          that.fuelType = fuelType.toString();
          that.isNewEnergy = isNewEnergy.toString();
          that.loanFlag = loanFlag.toString();
          that.newVehicle = newVehicle.toString();
          that.ownerIdtype = ownerIdtype.toString();
          that.ownerType = ownerType.toString();

          if (!that.$$.isValidObj(carkindCode)) {
            that.carkindCode = '0';
          }else {
            that.carkindCode = '1';
            that.trucksKindCode = carkindCode;
          }

          if (ownerType != '1') {
            that.ownerSex = 'O';
            that.recordDate = ownerBrithday;
          }else {
            // 身份证转换
            that.idCardConversion(ownerIdnumber);
          }
          that.queryCarInfoState = false;
        },
        queryCarInfo(val){
          // 根据车架号查询 - 历史车辆信息
          let that = this;
          that.axios.post(`/management/quotecarinsurance/queryCarInfo?frameNo=${val}`).then((response) => {
            let data = response.data;
            if (data.success) {
              const datas = data['datas'];
              if (!that.$$.isEmptyObject(datas)) queryCarInfoPicker(datas);
            } else {
              that.$message.error(data.msg);
            }
          });

          function queryCarInfoPicker(data) {
            let list = [], carName;

            for (let i in data){
              const {licenseNo, engineNo, vehicleBrand, vehicleModel, ownerName} = data[i];

              carName = `${licenseNo}|${vehicleBrand+vehicleModel}|${ownerName}|${engineNo}`;
              list.push({
                label: carName,
                value: i
              });
            }
            that.queryCarInfoSelectList = list;
            that.queryCarInfoList = data;

            if (list.length > 0) that.queryCarInfoState = true;
          }
        },
        submitOrder(){
          // 提交订单
          let that = this,
            {newVehicle, licenseNo} = that;

          //-- 校验
          const errorMsg = that.validationForm();
          if(that.$$.isValidObj(errorMsg)) return that.$message.error(errorMsg);

          that.saveCarInfo();
        },
        validationForm(){
          //-- 校验
          let that = this,
            reg_creditCode = /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g,                                                 // 统一社会信用代码正则
            {newVehicle, licenseNo, frameNo, engineNo, enrollDate, vehicleModel, seatCount, replacementValue, chgOwnerFlag, transferDate, company4s,
              ownerName, ownerIdnumber, ownerIdtype, ownerBrithday, recordDate} = that;

          // 不是新车，有车牌号码
          if (newVehicle == '0'){
            if(!that.$$.isValidObj(licenseNo)) return "请输入车牌号";

            if (licenseNo.length < 6) return "车牌号格式不正确~";
          }

          if(!that.$$.isValidObj(frameNo)) return "请按行驶证输入17位“车辆识别代号”";
          if(!that.$$.isValidObj(engineNo)) return "请按行驶证输入“发动机号”";
          if(!that.$$.isValidObj(enrollDate)) return "请按行驶证选择“注册日期”";
          if(!that.$$.isValidObj(vehicleModel)) return "请输入车辆型号";
          if(!that.$$.isValidObj(seatCount)) return "请按行驶证输入“车辆座位数”";
          /*if(!that.$$.isValidObj(replacementValue)) return "请输入新车购置价";
          if (parseInt(replacementValue) <= 0) return "新车购置价不能小于0";*/

          // 过户时间
          if (chgOwnerFlag == '1' && !that.$$.isValidObj(transferDate)) return "请选择过户日期";

          // 新车
          if (newVehicle == '1' && !that.$$.isValidObj(company4s)) return "请输入4S店名称";

          // 车主信息
          if(!that.$$.isValidObj(ownerName)) return "请输入车主真实姓名";
          if (that.$$.constant.nameReg.test(ownerName) === false) return "车主姓名格式不正确!";

          if(!that.$$.isValidObj(ownerIdnumber)) return "请输入证件号码";

          if (ownerIdtype == '1') {
            if (that.$$.constant.beInsureIdTypeOneReg.test(ownerIdnumber) === false) return "车主身份证格式不正确!";
            if (this.$$.getAge(ownerBrithday.replaceAll('-', '')) < 18) return "投保人年龄必须大于18周岁!";
            if(!that.$$.isValidObj(ownerBrithday)) return "请选择车主生日";
          }else if (ownerIdtype == '6') {
            if (reg_creditCode.test(ownerIdnumber) === false) return "统一社会信用代码格式有误!";
            if(!that.$$.isValidObj(recordDate)) return "请选择注册日期";
          }
        },
        saveCarInfo(){
          //-- 车险 - 保存车辆信息
          let that = this,
            {
              productId,
              beShareToken,                   // 分享token
              quoteIdNum,                     // 报价订单ID
              insuredCode,                    // 投保所在地 - 编码
              carkindCode,                    // 车辆类型
              trucksKindCode,                 // 货车类型
              useNatureCode,                  // 车辆使用性质，默认‘8A-家庭自用汽车’
              newVehicle,                     // 新旧车标志：1：是（未上牌）、0：不是，默认为0；
              ecdemicVehicle,                 // 外地车标志：1-是、0-不是；
              chgOwnerFlag,                   // 过户车标识：1：是、0：不是，默认为0
              loanFlag,                       // 是否车贷多年：1：是，0：否，默认为0
              licenseNo,                      // 车牌号
              frameNo,                        // 车架号
              engineNo,                       // 发动机号
              enrollDate,                     // 车辆注册日期：yyyy-MM-dd
              vehicleModel,                   // 车辆型号
              vehicleBrand,                   // 车辆品牌
              seatCount,                      // 座位数，包含驾驶位的座位数
              replacementValue,               // 新车购置价
              transferDate,                   // 过户日期（转移登记日期）：yyyy-MM-dd，过户车标识为1时显示必填
              companyProvince,                // 4S店公司所在省份编码
              companyCity,                    // 4S店公司所在地编码
              company4s,                      // 车辆销售公司名称，广东新车必录

              exhaustScale,                   // 排气量：单位：mL(整数8位，小数4位)，车辆种类为货车时必传
              fuelType,                       // 能源类型，非燃油是新能源车（0：燃油；1：纯电动；2：燃料电池；3：插电式混合动力；4：其他混合动力；9：其他；）
              fullWeight,                     // 整备质量：单位：千克，车辆种类为货车时必传
              isNewEnergy,                    // 是否新能源车，能源类型为0值为0，否则为1
              marketYear,                     // 上市年份：yyyy
              otherEnergyTypeDesc,            // 其他燃料（能源）种类描述，当能源类型为9-其他时，必填；
              pureRange,                      // 纯电续航里程，燃油类型不为0时显示，仅支持大于等于0的纯数字，支持小数点后1位，例如400.1；

              // 车主信息
              ownerType,                      // 车主性质：1：个人；2：机关/团体；3：企业；6：个体工商户（同企业）
              ownerIdtype,                    // 车主证件类型，车主性质个人：1-身份证，非个人：6-统一社会信用代码，
              ownerSex,                       // 车主性别
              ownerName,                      // 车主名称
              ownerIdnumber,                  // 车主证件号码
              ownerBrithday,                  // 车主生日
              recordDate,                     // 车主注册日期
          } = that;

          let params = {
            productId,
            //-- 分享Token
            beShareToken,
            //-- 报价订单ID
            quoteIdNum,
            // 车辆信息
            insuredCode,
            carkindCode: carkindCode == '0' ? '' : trucksKindCode,
            licenseNo: `粤${licenseNo}`,
            useNatureCode,
            newVehicle,
            frameNo,
            engineNo,
            enrollDate,
            vehicleModel,
            vehicleBrand,
            seatCount,
            ecdemicVehicle,
            chgOwnerFlag,
            transferDate,
            loanFlag,
            company4s,
            companyProvince,
            companyCity,

            exhaustScale,
            fuelType,
            fullWeight,
            isNewEnergy,
            marketYear,
            otherEnergyTypeDesc,
            pureRange,
            replacementValue,
            // 车主信息
            ownerType,
            ownerName,
            ownerIdtype,
            ownerIdnumber,
            ownerSex,
            ownerBrithday: ownerIdtype == '1' ? ownerBrithday : recordDate,
          };

          // console.log(params);
          // return;
          that.axios.post('/management/quotecarinsurance/saveCarInfo',params).then((response) => {
            let data = response.data;
            if (data.success) {
              const {datas} = data;

              let id = decodeURIComponent(encodeURIComponent(datas).replace(new RegExp("%20","gm"),"%2B"));
              that.quoteIdNum = id;
              // 修改 - URL全部参数
              let { origin, pathname } = window.location,
                params = {quoteIdNum: datas};

              const {beShareToken} = that;
              if (that.$$.isValidObj(beShareToken)) params[beShareToken] = beShareToken;

              let urlPars = that.$$.jsonToUrlParams(params),
                url = origin + pathname + urlPars;
              history.pushState("", "", url);

              that.carModelQuery();
            } else {
              that.$message.error(data.msg);
            }
          });
        },
        // 车型查询
        carModelQuery(){
          const that = this,
            { beShareToken, quoteIdNum, eventLogToken } = that;

          that.axios.post('/management/quotecarinsurance/carModelQuery',{
            quoteIdNum,
            beShareToken,
          }).then((response) => {
            let data = response.data;
            if (data.success) {
              const {datas} = data,
                {listSize, responseFlag, carList} = datas;
              $('#submitOrder').html('下一步');

              if (listSize == '1'){
                if (responseFlag == '4'){
                  setTimeout(function () {
                    let data = {};
                    if (that.$$.isValidObj(beShareToken)) data['beShareToken'] = beShareToken;
                    if (that.$$.isValidObj(eventLogToken)) data['eventLogToken'] = eventLogToken;
                    if (that.$$.isValidObj(quoteIdNum)) data['quoteIdNum'] = quoteIdNum;

                    that.$router.push({path: '/taiKang/premiumCalculation', query: data});
                  }, 500);
                }
              }else {
                that.carInfoList = carList;
                carInfoPicker(carList);
              }
            } else {
              that.$message.error(data.msg);
            }
          });

          function carInfoPicker(data) {
            let list = [];

            for (let i in data){
              const {carName} = data[i];
              list.push({
                label: carName,
                value: i
              });
            }
            that.carInfoSelectList = list;

            if (list.length > 0) that.carInfoState = true;
          }
        },
        // 保存车型查询信息
        saveCarModelQuery(data){
          const that = this,
            { beShareToken, quoteIdNum, eventLogToken } = that,
            {vehicleCode, vehicleHyCode, carModelKey, marketYear, replacementValue, displacement, seatCount, fullWeight, vehicleBrand, fuelType, responseFlag} = data;

          $(".replacementValue").val(replacementValue);

          that.axios.post('/management/quotecarinsurance/saveCarModelQuery',{
            quoteIdNum,
            beShareToken,
            vehicleCode,
            vehicleHyCode,
            carModelKey,
            marketYear,
            replacementValue,
            displacement,
            seatCount,
            fullWeight,
            vehicleBrand,
            fuelType
          }).then((response) => {
            let data = response.data;
            if (data.success) {
              if (responseFlag == '4'){
                setTimeout(function () {
                  let data = {};
                  if (that.$$.isValidObj(quoteIdNum)) data['quoteIdNum'] = quoteIdNum;
                  if (that.$$.isValidObj(beShareToken)) data['beShareToken'] = beShareToken;
                  if (that.$$.isValidObj(eventLogToken)) data['eventLogToken'] = eventLogToken;

                  that.$router.push({path: '/taiKang/premiumCalculation', query: data});
                }, 500);
              }else {
                that.carInfoState = false;
              }
            } else {
              that.$message.error(data.msg);
            }
          });
        },

      },
      mounted() {
        let that = this,
          quoteIdNum = that.$route.query.quoteIdNum,
          beShareToken = that.$route.query.beShareToken;

        if (that.$$.isValidObj(beShareToken)) that.beShareToken = beShareToken;
        if (that.$$.isValidObj(quoteIdNum)) {
          let id = decodeURIComponent(encodeURIComponent(quoteIdNum.toString()).replace(new RegExp("%20","gm"),"%2B"));
          that.quoteIdNum = id;
          that.getCarInfo();
        }

        // 获取 - 分享token
        that.createShareToken();

        // 事件绑定
        that.eventBinding();
      }
    }
</script>

<style scoped>
  @import "../../../../../static/css/dutyInsurance/fillInfo.css";

  .wrapper{
    overflow-x: auto;
  }

  .section{
    position: relative;
    min-width: 1000px;
    margin: 0 auto;
    padding: 2rem 5%;
    background: #FFFFFF;
    box-shadow: 0 0 1rem 0 rgba(203, 203, 203, 0.2);
  }
  .must{
    color: #FF7052;
    display: inline-block;
  }

  .customerIcon{
    width: 40px;
    height: 30px;
    background: #5677fc;
    display: inline-block;
    position: absolute;
    right: 0;
    border-radius: 20px 0 0 20px;
    top: -35px;
    z-index: 2;
  }
  .customerIcon .icon{
    background: url('../../../../../static/images/public/autoInsurance/customerIcon.png') no-repeat;
    width: 21px;
    height: 18px;
    display: inline-block;
    background-size: contain;
    margin-top: 6px;
    margin-left: 12px;
  }

  .vehicleInfo,
  .ownerInfo{
    padding: 3rem 0;
  }

  .vehicleInfo>li,
  .ownerInfo>li{
    position: relative;
    width: 49%;
    height: 50px;
    padding: 5px 0;
    background-color: #fff;
    display: inline-block;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    -webkit-user-select: none;
    -moz-user-select: none;
    font-size: 13px;
  }

  .vehicleInfo>li input,
  .ownerInfo>li input{
    width: 260px;
    height: 39px;
    padding: 0 5px;
    font-size: 14px;
    box-sizing: border-box;
    color: #ff7052;
    display: inline-block;
    outline: none;
    -webkit-appearance: none;
    -webkit-box-sizing: border-box;
    -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    border: 1px solid #DCDFE6;
    border-radius: 4px;
  }

  .section input::-webkit-input-placeholder {
    font-size: 14px!important;
  }

  .section /deep/ .el-input__inner,
  .section /deep/ .el-select,
  .section /deep/ .el-cascader{
    width: 260px;
    color: #ff7052;
  }

  .tit {
    width: 120px;
    color: #000;
    letter-spacing: 1px;
    display: inline-block;
    text-align: right;
  }

  .sInfo{
    width: 300px;
    height: 100%;
    line-height: 40px;
    color: #ff7052;
    display: inline-block;
    position: relative;
  }

  .newVehicle{
    display: inline-block;
  }

  .whetherAgree{
    color: #333333;
    margin-left: 8px;
    font-size: 14px;
  }
  .licenseNo{
    width: 120px!important;
  }

  textarea{
    width: 260px;
    height: 100%;
    line-height: 150%;
    color: #FF7052;
    padding: 0.625rem;
    background-color: #f2f4f7;
    resize: none;
    border-radius: 0.375rem;
    border: 1px solid #E8E8E8;
  }


  .ownerIdtypelabel,
  .ownerIdtypelabel /deep/ .el-input__inner,
  .ownerIdtypelabel /deep/ .el-select{
    width: 160px;
  }

  .carkindCode,
  .carkindCode /deep/ .el-input__inner,
  .carkindCode /deep/ .el-select{
    width: 160px;
  }

  /deep/ .el-dialog {
    top: 50%;
    transform: translate(0%, -50%);
    margin-top: 0!important;
  }

  .loadCarInfoList /deep/ .el-input__inner {
    border: none;
  }

  .loadCarInfoList /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 100%;
  }

  .loadCarInfoList /deep/ .el-select{
    display: block;
  }

  .idCardRecognition,
  .drivingPermitRecognition{
    font-size: 12px;
    color: #ff7052;
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;
    text-align: right;
  }

  .idCardRecognition img,
  .drivingPermitRecognition img{
    width: 23px;
    height: 23px;
    display: inline-block;
  }

  /* 弹窗 */
  .generalWrap .insuran-con{
    /*background-color: #F2F2F2;*/
    height: 100vh;
    padding-bottom: 0!important;
  }
  .generalWrap .headline{
    text-align: center;
    font-size: 16px;
    line-height: 50px;
    border-bottom: 1px solid #f5f5f5;
  }
  .generalWrap .topTips{
    color: #ff6503;
    background-color: #fbf0e2;
    padding: 5px 4%;
    margin: 10px 10px 0;
    font-size: 12px;
  }
  .generalWrap .content{
    background-color: white;
    text-align: center;
  }
  .generalWrap .content .title{
    font-size: 16px;
    margin: 30px auto 20px;
  }

  .generalWrap .content .exampleUnit{
    width: 16rem;
    height: 10rem;
    margin: 0 auto;
    position: relative;
    overflow: hidden;
  }

  .generalWrap .content .upload{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    background: #fff;
    z-index: 999;
    overflow: hidden;
  }
  .generalWrap .content .upload>input{
    opacity: 0;
    width: 100%;
    height: 100%;
  }

  .generalWrap .content .norm{
    margin: 20px auto;
    color: #999999;
  }
  .generalWrap .content .normList{
    padding: 0 8px;
    color: #999999;
  }
  .generalWrap .content .normList>div{
    width: 25%;
    padding: 0 1px;
  }
  .generalWrap .content .normList .example{
    width: 100%;
    background: #fff;
    border: 0.013333rem solid #f1b207;
  }
  .generalWrap .content .normList .explain{
    color: #999999;
    padding-top: 3px;
    position: relative;
  }
  .generalWrap .content .normList .explain img{
    width: 1.3rem;
    display: inline-block;
    vertical-align: middle;
  }
  .generalWrap .content .normList .explain span{
    display: inline-block;
    vertical-align: middle;
    margin-left: -3px;
  }


  .generalWrap .healthSubmitBtn{
    width: calc(49% - 2em);
    margin: 2em 1em;
    text-align: center;
    background-color: #e8e7e7;
    color: white;
    font-size: 1.2em;
    padding: .6em 0;
    border-radius: .5em;
    display: inline-block;
  }
  .healthSubmitBtn.on{
    background-color: #ff7052;
  }

</style>



// WEBPACK FOOTER //
// src/components/product/autoInsurance/taikang/vehicleInfo.vue